import { SITE_URL, SITE_NAME } from './seo';

export interface FAQItem {
  question: string;
  answer: string;
}

export function generateOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    description: 'Calculadora fiscal profesional para autónomos en España. Calcula IRPF, cuota de autónomos (RETA) e IVA de forma precisa y actualizada.',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: 'Spanish',
    },
    sameAs: [],
  };
}

export function generateWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: 'Calculadora fiscal profesional para autónomos en España.',
    inLanguage: 'es-ES',
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
    },
  };
}

export function generateSoftwareApplicationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Autónomo Claro - Calculadora Fiscal',
    applicationCategory: 'FinanceApplication',
    operatingSystem: 'Web',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'EUR',
    },
    description: 'Calculadora profesional para autónomos que permite calcular IRPF, cuota de autónomos (RETA) e IVA con la normativa fiscal actualizada de 2025.',
    featureList: [
      'Cálculo de IRPF por tramos',
      'Cuota de autónomos (RETA) por ingresos reales',
      'Simulación de IVA trimestral',
      'Modelo 130 - Pagos fraccionados',
      'Comparador de escenarios',
      'Exportación a PDF',
    ],
    inLanguage: 'es-ES',
    url: SITE_URL,
  };
}

export function generateArticleSchema(
  title: string,
  description: string,
  datePublished: string,
  dateModified: string,
  url: string
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    datePublished: datePublished,
    dateModified: dateModified,
    author: {
      '@type': 'Organization',
      name: SITE_NAME,
    },
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: {
        '@type': 'ImageObject',
        url: `${SITE_URL}/logo.png`,
      },
    },
    url: url,
    inLanguage: 'es-ES',
  };
}

export function generateFAQSchema(faqs: FAQItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function generateBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
